import { createSelector } from '@reduxjs/toolkit';
import { slice } from './slice';
export const fieldsReducer = slice.reducer;
export * from './actions';
export * from './store';
export const fieldsStoreSelector = createSelector((state)=>state.fields, (fields)=>fields);
